import { apiCrm } from '../../../../http';
import { calculateOffsetFromPageAndLimit } from 'views/CRM/shared/utils/pagination';

class AccountService {
  getAccounts(recordTypeId, params = {}, headers = { page: 1, limit: 10 }) {
    const offset = calculateOffsetFromPageAndLimit(headers.page, headers.limit);
    return apiCrm.get(`/account/${recordTypeId}`, {
      params,
      headers: { ...headers, offset }
    });
  }

  getAllAccounts(params = {}, headers = { page: null, limit: null }) {
    let offset = null;

    if (headers.page !== null && headers.limit !== null) {
      offset = calculateOffsetFromPageAndLimit(headers.page, headers.limit);
    }

    const queryParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== null && value !== undefined) {
        queryParams.append(key, value);
      }
    });
    return apiCrm.get(`account`, {
      params: queryParams,
      headers: {
        page: headers.page || null,
        limit: headers.limit || null,
        offset: offset || null
      }
    });
  }

  create(recordTypeId, data) {
    return apiCrm.post(`account/${recordTypeId}`, data);
  }

  update(accountId, data) {
    return apiCrm.put(`account/${accountId}`, data);
  }

  getById(recordTypeId, id) {
    return apiCrm.get(`account/${recordTypeId}/${id}`);
  }

  removeContacts(accountId, contactIds = []) {
    return apiCrm.put(`account/${accountId}/remove-contacts`, { contactIds });
  }

  importAccounts(recordTypeId, data) {
    return apiCrm.post(`account/${recordTypeId}/import`, data);
  }

  deleteAccount(accountId) {
    return apiCrm.delete(`account/${accountId}`);
  }
  getAccountsComments(accountId) {
    return apiCrm.get(`accounts-comment/${accountId}`);
  }
  createAccountsComments(accountId, data) {
    return apiCrm.post(`accounts-comment/${accountId}`, data);
  }
  updateAccountsComments(commentId, data) {
    return apiCrm.put(`accounts-comment/${commentId}`, data);
  }
  deleteAccountsComments(commentId) {
    return apiCrm.delete(`accounts-comment/${commentId}`);
  }
  async getExcel(params) {
    return apiCrm.get('/export-account-xlsx', {
      params,
      responseType: 'arraybuffer'
    });
  }

  async getCsv(params) {
    return apiCrm.get('/export-account-csv', {
      params,
      responseType: 'arraybuffer'
    });
  }
}

export default new AccountService();
